import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFolder2"><Path d="M2 5.5C2 4.11929 3.11929 3 4.5 3H9.09194C9.73161 3 10.3469 3.24519 10.8113 3.68512L11.7653 4.58893C12.0439 4.85288 12.4131 5 12.7969 5H19.5C20.8807 5 22 6.11929 22 7.5V9.49982C21.5822 9.18597 21.0628 9 20.5 9H3.5C2.9372 9 2.41783 9.18597 2 9.49982V5.5Z" fill="currentColor"/><Path d="M2 11.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V11.5C22 10.6716 21.3284 10 20.5 10H3.5C2.67157 10 2 10.6716 2 11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder2;
